<template>
  <div class="row">
    <div class="form-group col-6">
      <input class="form-control" type="number" v-model="overtime.percent" />
    </div>
    <div class="form-group col-6">
      <input class="form-control" type="number" v-model="overtime.hours" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["overtime"]
};
</script>